import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PbpData from "../data/proxmoxBackupPlans.json";

const PbpPage = () => {
  const [pageData, setPageData] = useState({});
    useEffect(() => {
        if (PbpData?.Pbp?.length > 0) {
        setPageData(PbpData.Pbp[0]);
        }
    }, []);
    if (!pageData) return <p>Loading...</p>;

  return (
    <>
        <div className="page-title">
          <div className="container py-5">
            <h2 className="title position-relative">{pageData.title}</h2>
          </div>
        </div>

        <section className="product-section vps-hosting">
          <div className="container">
            <div className="row">
                <div className="col">
                    <div className="section-title text-center">
                        <h2>{pageData.subTitle}</h2>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <div class="section-title text-center">
                        <h2 class="title position-relative">Dedicated Backup Server Plans</h2>
                    </div>
                </div>
            </div>

            <div className="row">
                {pageData?.plansDedicated?.length > 0 &&
                    pageData.plansDedicated.map((product, idc) => (
              <div key={idc} className="col-lg-4 col-md-4 col-sm-6 my-5">
                <div className="product-card">
                    <div className="clean-pricing-item">
                        
                        {/* <div className="ribbon"><span>{product.ribbon}</span></div> */}

                        <table className="table table-bordered pricing-table text-center">
                            <thead>
                                    <tr>
                                    <td><h4>{product.title}</h4><span className="price">{product.price}</span> /mo.<br />{product.setup}<br /><a className="text-light btn btn-custom btn-lg" href={product.order_link}>Order Now</a></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product.features.map((feature, i) => (
                                        <tr key={i}>
                                        <td>{feature}</td>
                                        </tr>
                                    ))}
                                </tbody>
 
                        </table>

                    </div>
                </div>
              </div>
              ))}
              {/*colend*/}
            </div>

            <div className="row">
                <div className="col">
                    <div class="section-title text-center">
                        <h2 class="title position-relative">Shared (Non-Dedicated) Backup Plans</h2>
                        <p>These plans provide backup storage access via a centralized Proxmox Backup Server instance with individual access control.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                {pageData?.plansNonDedicated?.length > 0 &&
                    pageData.plansNonDedicated.map((product, idc) => (
              <div key={idc} className="col-lg-3 col-md-6 col-sm-6 my-5">
                <div className="product-card">
                    <div className="clean-pricing-item">
                        
                        {/* <div className="ribbon"><span>{product.ribbon}</span></div> */}

                        <table className="table table-bordered pricing-table text-center">
                            <thead>
                                    <tr>
                                    <td><h4>{product.title}</h4><span className="price">{product.price}</span> /mo.<br /><a className="text-light btn btn-custom btn-lg" href={product.order_link}>Order Now</a></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product.features.map((feature, i) => (
                                        <tr key={i}>
                                        <td>{feature}</td>
                                        </tr>
                                    ))}
                                </tbody>
 
                        </table>

                    </div>
                </div>
              </div>
              ))}
              {/*colend*/}
            </div>

            
            <div className="row">
              <div className="col">
                <div className="txt-wrap py-3">
                <div class="section-title">
                  <h4 className="mb-3">What’s Included in Your Setup Fee?</h4>
                  <ul className="product-features">
                    <li><i class="fa fa-check"></i>&nbsp;Proxmox Backup Server pre-installed and ready to use.</li>
                    <li><i class="fa fa-check"></i>&nbsp;pfSense firewall layer filters all access.</li>
                    <li><i class="fa fa-check"></i>&nbsp;Only ports 22 (SSH) and 8007 (PBS Web UI) are allowed.</li>
                    <li><i class="fa fa-check"></i>&nbsp;Access permitted only from customer's dynamic IP or DynDNS hostname.</li>
                    <li><i class="fa fa-check"></i>&nbsp;All other inbound traffic is blocked.</li>
                    <li><i class="fa fa-check"></i>&nbsp;Static IP address included for each plan.</li>
                  </ul>
                  </div>
                  </div>
              </div>
            </div>

          </div>
        </section>
    </>
  );
};

export default PbpPage;
